var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayEds)?_c('eds-create',{ref:"edsCreateDialog",on:{"mounted":_vm.onMountedEdsCreate}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }